/**
 * The thresholds that decide what counts as a trial, a live account, money
 * received, and which conditions raise a flag.
 */
import { useApp } from '../../store/AppContext.jsx';
import { Section, Grid, NumberField, MembershipChecks, CheckGrid, Toggle } from './SettingsBits.jsx';

export default function RulesPane() {
  const { S, patchSettings } = useApp();

  /* The second overdue bucket has to stay above the first. */
  const guardBuckets = () => {
    if (S.ageLate <= S.ageMid) patchSettings({ ageLate: S.ageMid + 1 });
  };

  return (
    <>
      <Section title="Timings" hint="These drive the trial meter, renewal warnings and ageing buckets.">
        <Grid>
          <NumberField label="Trial length" name="trialDays" unit="days on the meter" min={1} max={90} />
          <NumberField label="Renewal warning" name="renewWindow" unit="days before expiry" min={1} max={365} />
          <NumberField label="Gone quiet after" name="staleDays" unit="days with no activity" min={1} max={365} />
          <NumberField label="Chase cools off" name="snoozeDays" unit="days after logging contact" min={0} max={90} />
          <div onBlur={guardBuckets}>
            <NumberField label="First overdue bucket" name="ageMid" unit="days" min={1} max={365} />
          </div>
          <div onBlur={guardBuckets}>
            <NumberField label="Second overdue bucket" name="ageLate" unit="days" min={2} max={730} />
          </div>
        </Grid>
      </Section>

      <Section title="Counts as active" hint="Statuses treated as a live account.">
        <MembershipChecks sourceKey="statuses" targetKey="liveStatuses" />
      </Section>

      <Section title="Counts as paid" hint="Payment values meaning money has been received.">
        <MembershipChecks sourceKey="payments" targetKey="paidValues" />
      </Section>

      <Section title="Excluded from metrics" hint="Types kept out of conversion, chasing and counts.">
        <MembershipChecks sourceKey="types" targetKey="excluded" />
      </Section>

      <Section title="Alerts to raise" hint="Turn off anything your team does not want in the queue.">
        <CheckGrid>
          <Toggle label="No owner assigned" name="flagNoOwner" />
          <Toggle label="No contact person" name="flagNoContact" />
          <Toggle label="No recent activity" name="flagStale" />
          <Toggle label="Trial with no end date" name="flagNoTrialDate" />
        </CheckGrid>
      </Section>
    </>
  );
}
